import { common } from '../common.js';
import { RESIDENCY_DEADLINES } from '../deadlines.js';
import type { IProgram } from '../types.js';

export const CITIZENSHIP: IProgram = {
  id: 'citizenship',
  name: 'Canadian citizenship (adults)',
  short: 'Citizenship',
  family: 'citizenship',
  status: 'active',
  version: '2026-10-04',
  review: 'pending',
  sources: [{ title: 'IRCC: Apply for citizenship', url: 'https://www.canada.ca/en/immigration-refugees-citizenship/services/canadian-citizenship/become-canadian-citizen/apply.html', retrieved: '2026-10-04' }],
  questions: [
    { id: 'age55', text: 'Is the applicant between 18 and 54 (language proof needed)?', kind: 'yesno' }
  ],
  roles: [{ id: 'principal', label: 'Applicant', min: 1, max: 1 }],
  sections: ['Forms', 'Eligibility', 'Identity and civil documents', 'Fees'],
  items: [
    { id: 'personalChecklist', label: 'IRCC document checklist for the citizenship application', section: 'Forms', forRoles: 'application', source: 0 },
    { id: 'presence', label: 'Physical presence calculation (at least 1,095 days in the 5 years before applying)', section: 'Eligibility', forRoles: ['principal'], source: 0 },
    { id: 'taxes', label: 'Proof of filing taxes for the required years', section: 'Eligibility', forRoles: ['principal'], source: 0 },
    { id: 'language', label: 'Proof of English or French ability', section: 'Eligibility', forRoles: ['principal'], when: { q: 'age55', is: true }, source: 0 },
    { id: 'prDocument', label: 'Permanent resident card or confirmation of permanent residence', section: 'Identity and civil documents', forRoles: ['principal'], source: 0 },
    { id: 'ids', label: 'Two pieces of personal identification', section: 'Identity and civil documents', forRoles: ['principal'], source: 0 },
    common.passport(0, ['principal']),
    { id: 'photos', label: 'Citizenship photos', section: 'Identity and civil documents', forRoles: ['principal'], source: 0 },
    common.representative(0),
    common.fees(0)
  ],
  deadlines: []
};

export const PR_CARD: IProgram = {
  id: 'pr-card',
  name: 'Permanent resident card (renewal or replacement)',
  short: 'PR card',
  family: 'citizenship',
  status: 'active',
  version: '2026-10-04',
  review: 'pending',
  sources: [
    { title: 'IRCC: PR card, apply, renew or replace', url: 'https://www.canada.ca/en/immigration-refugees-citizenship/services/new-immigrants/pr-card/apply-renew-replace.html', retrieved: '2026-10-04' },
    { title: 'IRCC: Permanent resident card', url: 'https://www.canada.ca/en/immigration-refugees-citizenship/services/permanent-residents/card.html', retrieved: '2026-10-04' }
  ],
  questions: [],
  roles: [{ id: 'principal', label: 'Permanent resident', min: 1, max: 1 }],
  sections: ['Forms', 'Eligibility', 'Identity and civil documents', 'Fees'],
  items: [
    { id: 'personalChecklist', label: 'IRCC document checklist for the PR card application', section: 'Forms', forRoles: 'application', source: 0 },
    { id: 'residency', label: 'Proof of meeting the residency obligation (730 days in the last 5 years)', section: 'Eligibility', forRoles: ['principal'], source: 1 },
    { id: 'currentCard', label: 'Current or expired PR card (or confirmation of permanent residence)', section: 'Identity and civil documents', forRoles: ['principal'], source: 0 },
    common.passport(0, ['principal']),
    { id: 'photos', label: 'PR card photos', section: 'Identity and civil documents', forRoles: ['principal'], source: 1 },
    common.representative(0),
    common.fees(0)
  ],
  deadlines: []
};

export const PRTD: IProgram = {
  id: 'prtd',
  name: 'Permanent resident travel document (PRTD)',
  short: 'PRTD',
  family: 'citizenship',
  status: 'active',
  version: '2026-10-04',
  review: 'pending',
  sources: [{ title: 'IRCC: Permanent resident travel document', url: 'https://www.canada.ca/en/immigration-refugees-citizenship/services/permanent-residents/travel-document.html', retrieved: '2026-10-04' }],
  questions: [],
  roles: [{ id: 'principal', label: 'Permanent resident (outside Canada)', min: 1, max: 1 }],
  sections: ['Forms', 'Eligibility', 'Identity and civil documents', 'Photos and police certificates', 'Fees'],
  items: [
    { id: 'personalChecklist', label: 'IRCC document checklist for the PRTD application', section: 'Forms', forRoles: 'application', source: 0 },
    { id: 'residency', label: 'Proof of meeting the residency obligation, or the humanitarian reasons why not', section: 'Eligibility', forRoles: ['principal'], source: 0 },
    common.passport(0, ['principal']),
    { id: 'prDocument', label: 'PR card or confirmation of permanent residence', section: 'Identity and civil documents', forRoles: ['principal'], source: 0 },
    common.photos(0, ['principal']),
    common.representative(0),
    common.fees(0)
  ],
  deadlines: RESIDENCY_DEADLINES
};
